import dayjs from 'dayjs';

export const formatMessageDate = (date: Date | null) => {
  if (!date) return '';
  return dayjs(date).format('MMMM D, YYYY').toLowerCase();
};
